const CLAVE_SESION = 'caja_pvc_sesion';

function guardarSesion({ token, operador }) {
  localStorage.setItem(CLAVE_SESION, JSON.stringify({ token, operador }));
}

function obtenerSesion() {
  try {
    const guardado = localStorage.getItem(CLAVE_SESION);
    return guardado ? JSON.parse(guardado) : null;
  } catch (err) {
    return null;
  }
}

function cerrarSesion() {
  localStorage.removeItem(CLAVE_SESION);
}

function actualizarOperador(cambios) {
  const sesion = obtenerSesion();
  if (!sesion) return;
  guardarSesion({ ...sesion, operador: { ...sesion.operador, ...cambios } });
}

export { guardarSesion, obtenerSesion, cerrarSesion, actualizarOperador };
